module.exports = __webpack_public_path__ + "static/img/advModel2.607f416a.png";